import { UpdateCountryAndState } from './countries';
import * as models from './models';

export declare interface Address {
    fullName: string;
    company: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;

    state?: models.State;

    zip: string;

    country?: models.Country;
}

export async function Format(a: Address | models.ShippingOption | models.PaymentOption): Promise<string> {
    await UpdateCountryAndState(a);

    const lines: string[] = [];
    if (a.fullName) {
        lines.push(a.fullName);
    }
    if (a.company) {
        lines.push(a.company);
    }
    const addr = [a.addressLine1, a.addressLine2].filter(Boolean).join(', ');
    if (addr.length) {
        lines.push(addr);
    }
    let city: string;
    switch (a.country?.countryCode2) {
    case 'CN':
    case 'IN':
        city = [[a.city, a.state?.stateCode].filter(Boolean).join(', '), a.zip].filter(Boolean).join(' ');
        break;
    case 'US':
    case 'CA':
    case 'AU':
        city = [a.city, a.state?.stateCode, a.zip].filter(Boolean).join(' ');
        break;
    default:
        city = [a.zip, a.city].filter(Boolean).join(' ');
        break;
    }
    if (city) {
        lines.push(city);
    }
    if (a.country?.name) {
        lines.push(a.country.name);
    }

    return lines.filter(Boolean).join('\n');
}